import React from 'react'

import CTACard from '../layout/CtaCard'
import PremiumTag from '../premium/Tag'
import Tag from '../content/Tag'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = { title: string; subtitle: string; onClick: (title: string) => void; isSelected?: boolean, isPremium?: boolean, inProgress?: boolean }

const ToolCard: React.FC<Props> = ({ title, subtitle, onClick, isSelected = false, isPremium = false, inProgress }) => {
  const { t } = useI18N()
  return (
    <CTACard
      onClick={() => onClick(title)}
      className={isSelected ? 'border-solid border-2 border-deep-green text-deep-green' : ''}
    >
      <div>
        <div className='font-semibold text-sm flex items-center gap-x-4 pb-2'>
          {title}
          {isPremium && <PremiumTag />}
          {inProgress ? <Tag solid variant='electric-green'>{t('interviewer.ai.progress')}</Tag> : <div />}
        </div>
        <div className='font-normal text-sm text-gray-600'>{subtitle}</div>
      </div>
    </CTACard>
  )
}

export default ToolCard
